import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authFetch } from '../utils/authFetch';
import i18n from '../i18n';

export function RequireAuth({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);

  useEffect(() => {
    const verify = async () => {
      const res = await authFetch('/api/me');

      if (res.ok) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }

      setLoading(false);
    };

    verify();
  }, []);

  if (loading) return <div className="text-center p-6">Загрузка...</div>;

  if (!isAuthenticated) {
    return <Navigate to={`/${lang}/login`} state={{ from: location }} replace />;
  }

  return children;
}
